:host {
  display: inline-block;
  line-height: 0;
  vertical-align: middle;
}